import useContactCreateRouteConfig from "../../../routes/configs/contacts/ContactCreateRouteConfig";
import useContactEditRouteConfig from "../../../routes/configs/contacts/ContactEditRouteConfig";
import useEditRowActionConfig from "../main/config/rowAction/default/EditRowActionConfig";
import useDeleteRowActionConfig from "../main/config/rowAction/default/DeleteRowActionConfig";
import useCreateHeaderActionConfig from "../main/config/headerAction/default/CreateHeaderActionConfig";
import DataTable, { useDataTable } from "../main/DataTable";
import DataTableConfig from "../main/config/dataTable/DataTableConfig";
import useBasicColumnConfig from "../main/config/column/default/BasicColumnConfig";
import useTimestampColumnConfig from "../main/config/column/default/TimestampColumnConfig";

function ContactsDataTable() {
  //Create the datatable config
  const config = new DataTableConfig("contacts");

  //Set the datatable fetch info
  config.setFetchRequest("contacts");
  config.setFetchParams({ with_contact_location_data: true });

  //Set the datatable order by
  config.setOrderBy("name");
  config.setOrderDirection("asc");

  //set the datatable columns
  config.setColumns([
    useBasicColumnConfig("location.name"),
    useBasicColumnConfig("name").setLockActive(true),
    useBasicColumnConfig("phone_number"),
    useTimestampColumnConfig("created_at"),
    useTimestampColumnConfig("updated_at"),
  ]);

  //Set the datatable row actions
  config.setRowActions([
    useEditRowActionConfig("contact", useContactEditRouteConfig()),
    useDeleteRowActionConfig("contact"),
  ]);

  //Set the datatable header actions
  config.setHeaderActions([
    useCreateHeaderActionConfig("contact", useContactCreateRouteConfig()),
  ]);

  //Create the datatable object
  const dataTable = useDataTable(config);

  return <DataTable controller={dataTable} />;
}

export default ContactsDataTable;
